<template>
  <AppGradientBackground>
    <AppSkipLink href="#main" />
    <HeaderNavBar />
    <div class="min-h-screen pb-80">
      <AppBanner />
      <AppBreadcrumbs :page-name="pageName" />
      <div class="page-wrapper">
        <GlobalNotificationContainer :show="!!notifications.title" />
      </div>
      <main id="main">
        <slot />
      </main>
    </div>
    <AppFooter />
  </AppGradientBackground>
</template>

<script lang="ts" setup>
const notifications = useNotificationStore();
const pageName = (useAttrs()['page-name'] as string) || '';
</script>

<style lang="scss" scoped></style>
